declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, CounsellingPlanRequest, CounsellingPlanController, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'viewmedicinetest',
  templateUrl: './viewmedicinetest.modal.html',
  styleUrls: ['./viewmedicinetest.modal.scss']
})

export class NgbViewMedicineTestModal implements OnInit {


    @Input() ActorDocCode;
    @Input() ScanDate: Date;
  @Input() DownloadActorImageFileExtension: string;
  @Input() DownloadActorImageFile: string;
  @Input() FormattedCode: string;
  @Input() CanEdit: number;
    @Input() CanShow: number;
    @Input() CycleCode: number;
    @Input() ActorCode: number;

  DOB: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  StartDate: NgbDateStruct;
  EndDate: NgbDateStruct;
  RecommendedPackage: string;
  Doctor: string;
  PackageCost: number;
  SelectEmi: boolean;
   public FacilityName: string;
  Concerns: string;
  AddRemarks: string;
  file: File;
  fileList: FileList;



  FileExtension: string = "";
  MaritalStatus: string;
  JobType: string;
  public isRequesting: boolean = false;
  public ShowList: boolean = true;
  public isEdit: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  private isvisible = true;
  DocFriendlyName: string = "";
  

  CurrentSaveCounsellingPlanRequest: SaveCounsellingPlanRequest;
  CurrentEditCounsellingPalnRequest: SaveCounsellingPlanRequest;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  CurrentActorDocController: ActorDocController[];

  @ViewChild('f') IdentitiesForm: NgForm;
  public UploadActorDoc: any;

  public CanDownLoadActorDoc: number

  public CanNurseView: number =0 ;

  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    
    //alert('Checking Forma ' + this.FormattedCode);
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

          //this.LoadPatientCounsellingPlansIfAny();
         


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
    CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
    ActivityCodeInfo: TreatmentCycleActiityMasterController;
    CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

    LoadMasterReq() {
        //alert("ScansData")
        this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCycleActiityMasterController();
    }

    GetTreatmentCycleActiityMasterController() {
        this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
        //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
        this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    this.LoadTestData();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.GetCycleActivity(this.ActorCode, this.ScanDate);

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    GetCycleActivity(ActorCode: number, ScanDate: Date): TreatmentCycleActiityMasterController[] {
        alert(ActorCode);
        alert(ScanDate);
        return this.CurrentTreatmentCycleActiityMasterController.filter(
            function (v, i, d) {
                
                return v.ActorID == ActorCode && v.DocDate == ScanDate;
            }
        )

    }
    CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
    CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

    LoadTestData() {
        //alert("ScansData")
        this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleTestByCodeController();
    }

    GetIvfCycleTestByCodeController() {
        this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.GetCycleActivity(this.ActorCode, this.ScanDate)[0].CycleActivityCode;
           // this.CurrentTreatmentCycleActiityMasterController[0].CycleActivityCode;
        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  
  //ActorCode: number;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
    ngOnInit() {
        this.LoadMasterReq();
        this.LoadTestData();
    //this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    //this.LoadPatients();
    this.CurrentSaveCounsellingPlanRequest = new SaveCounsellingPlanRequest();
   
    this.CurrentSaveCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.CurrentEditCounsellingPalnRequest = new SaveCounsellingPlanRequest();
    //this.CurrentEditCounsellingPalnRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentEditCounsellingPalnRequest = new SaveCounsellingPlanRequest();
    this.CurrentEditCounsellingPalnRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }



 
 
  
private stopRefreshing() {
  this.loaderService.displayLoader(false);
  this.isRequesting = false;
}
  private StartRefreshing() {
  this.loaderService.displayLoader(true);
  this.isRequesting = true;
  }
  
  back() {
    this.ShowList = true;
    this.isEdit = false;
  }
onAssignedToActorCode(event: any) {

    if (event != null) {
  //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
        this.CurrentSaveCounsellingPlanRequest.BranchCode = event;
       // console.log('event--_>' + event);
   //   }
    }

  }
  FacilityCode: number;
  //isvisiblebutton() {
    
  //  this.isvisible = false;
  //}
  
  //PlansActive_Var: boolean = false;
  //NoPlansActive() {
  //  this.PlansActive_Var = false;
  //  if (this.CurrentCounsellingPlanController.length > 0) {
      
  //    var index = this.CurrentCounsellingPlanController.length;
  //    while (index > 0) {
  //      index--;
  //      if (this.CurrentCounsellingPlanController[index].PlanStatus == 'Completed' ||
  //        this.CurrentCounsellingPlanController[index].PlanStatus == 'Cancelled') {
  //        this.PlansActive_Var = false;
  //        break;

  //      }
  //    }
  //  }
  //  else {
  //    this.PlansActive_Var = true;
  //  }
   

  //}
}





  //GetActorDocController() {
  //  this.StartRefreshing();
  //  this.docservice.GetActorDocController(this.CurrentActorDocRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentActorDocController = this.ApiResData.Result;
  //        this.initGridButton();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //    (error) => {

  //      if (error == "401 - Unauthorized") {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();



  //      }
  //      else {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();
  //      }
  //    }


  //    );

  //}

  

  /////////////////////////



  //

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start














  /////////////////////////

